module.exports = __webpack_public_path__ + "static/media/how-we-work.c641cdd4.jpg";